/**
 * Configuration constants for document uploads when creating posts via AI.
 * These constants are shared between frontend and backend to ensure consistency.
 */

export const ALLOWED_POST_DOCUMENT_EXTENSIONS = ['.docx', '.pptx'] as const;
export const MAX_POST_DOCUMENT_SIZE_BYTES = 25 * 1024 * 1024; // 25 MB

export const POST_DOCUMENT_UPLOAD_CONFIG = {
  allowedExtensions: ALLOWED_POST_DOCUMENT_EXTENSIONS,
  maxSizeBytes: MAX_POST_DOCUMENT_SIZE_BYTES,
} as const;
